export const getCDNUrl = (url) => {
  if (!url || url === '') {
    return 'https://ik.imagekit.io/anehqc9js/api/tr:n-normal/nophoto.png';
  }
  
  const apiBase = 'https://api.sporthood.in';
  const cdnBase = 'https://ik.imagekit.io/anehqc9js/api/tr:n-normal';
  const wwwBase = 'https://www.sporthood.in';
  const imageKitBase = 'https://ik.imagekit.io';

  if (url.startsWith(imageKitBase)) {
    return url;
  }
  
  // Handle full URLs
  if (url.startsWith('http')) {
    // API server URLs → CDN
    if (url.startsWith(apiBase)) {
      return url.replace(apiBase, cdnBase);
    }
    // www.sporthood.in URLs → CDN (if they're media files)
    else if (url.startsWith(wwwBase) && url.includes('/assets/')) {
      // Convert: https://www.sporthood.in/assets/img/avatar.png
      // To: https://ik.imagekit.io/anehqc9js/tr:n-normal/assets/img/avatar.png
      const path = url.replace(wwwBase, '');
      return `https://ik.imagekit.io/anehqc9js/tr:n-normal${path}`;
    }
    // External URLs → return as-is (might need CORS proxy)
    return url;
  }
  
  // Handle relative paths
  // Remove leading slash if present
  const cleanPath = url.startsWith('/') ? url.substring(1) : url;
  
  // Check if it's a media file
  if (cleanPath.startsWith('media/')) {
    return `${cdnBase}/${cleanPath}`;
  }
  // Check if it's a static asset
  else if (cleanPath.startsWith('static/') || cleanPath.startsWith('assets/')) {
    return `https://ik.imagekit.io/anehqc9js/tr:n-normal/${cleanPath}`;
  }
  // Default: assume it's a media file
  else {
    return `${cdnBase}/${cleanPath}`;
  }
};